/* tslint:disable */
/* eslint-disable */
/**
 * e-SNRWB
 * Opis api e-SNRWB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetParams
 */
export interface GetParams {
    /**
     * 
     * @type {string}
     * @memberof GetParams
     */
    id: string;
}

export function GetParamsFromJSON(json: any): GetParams {
    return GetParamsFromJSONTyped(json, false);
}

export function GetParamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetParams {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function GetParamsToJSON(value?: GetParams | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}


